<template>
  <div class="view">
    <div class="">

      <!-- <div class="text-center text-2xl max-w-xl mx-auto mt-16 serif">
        Explore the collection in your daily environment
      </div> -->

      <!-- <div
      class="text-white absolute bottom-0 right-0 left-0 p-6 m-auto text-center w-full max-w-2xl serif text-2xl z-10"
      >
        A collection of artwork in the daily environment
      </div> -->

      <div class="media-viewer">
        <!-- <flickity ref="flickity" :options="flickityOptions">
          <div class="cell" v-for="m in media" :key="m.url">
            <div class="">
              <img :src="getUrl(m.url)" alt="" class="media">
              <div class="caption text-xs py-2">
                By @jason123456 on 25 Jun 2021
              </div>
            </div>
          </div>
        </flickity> -->
      </div>

      <div class="media-grid">
        <div class="grid-cell" v-for="m in media" :key="m.id">
          <div class="image-wrapper"
          :style="{
            'backgroundImage':`url(${m.url})`
            }"
          >
            <!-- <img :src="getUrl(m.url)" alt="" class="media"> -->
          </div>
          <div class="caption text-xs py-2">
            {{m.caption}}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// import Flickity from 'vue-flickity';
// import 'flickity-imagesloaded'

import {gallery} from '@/common/content.js'
import mdFile from '@/markdown/about.md'
// @ is an alias to /src
export default {
  name: 'Restitution',

  components: {
    // Flickity
  },

  data () {
    return {
      text: '',
      flickityOptions: {
        // selector: '.item',
        cellAlign: 'center',
        draggable: true,
        pageDots: false,
        prevNextButtons: false,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        bgLazyLoad: 1,
        wrapAround: true, // true
        // freeScroll: true,
        imagesLoaded: true,
        // autoPlay: false,
        // selectedAttraction: 0.01,
        // friction: 0.15,
        contain: true,
        // any options from Flickity can be used
      }
    }
  },
  computed: {
    stage () {
      return this.$store.state.stage
    },
    md () {
      return mdFile
    },
    isTouch () {
			  return (('ontouchstart' in window) ||
			     (navigator.maxTouchPoints > 0) ||
			     (navigator.msMaxTouchPoints > 0));
    },
    media () {
      return gallery
    }
  },
  methods: {
    getUrl (url) {
      console.log(url)
      return `${url}`
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  pointer-events: auto;
  max-width: 100%;
  width: 100%;
  // background: rgba(38, 35, 34, 1);
  // background: blue;
}

.media-grid {

  @apply w-full p-4 pt-24;
  @screen lg {
    @apply pt-24 p-16 flex flex-wrap justify-start;
  }

  .grid-cell {
    @apply w-full overflow-hidden mb-6;
    @screen lg {
      @apply w-1/3 mb-8 p-4;
    }
    .image-wrapper {
      @apply w-full h-0 bg-cover bg-center;
      padding-bottom: 100%;
    }
  }
}

.media-viewer {
  @apply absolute inset-0;
  width: 100%;
  height: 100%;
  // margin-bottom: 100px;
  // @apply flex flex-wrap justify-center py-16;

  .cell {
    @apply flex justify-center items-center;
    width: 65vw;
    height: 100vh;

    @screen lg {
      width: 50vw;
      height: 100vh;
    }
  }
  .media {

    height: 60vh;
    width: auto;

    @screen lg {
      height: 60vh;
      width: auto;
    }
  }
}
</style>
